/**
 * This class to maintain share data that can be reused among application
 */
export class ApplicationState implements ProxyModel.OrganisationViewModel {
    organisationShortName: string;
    isOfba: boolean = false;
    isSideBarMiniActive : boolean;
    maxFileSizeAllowConfig : ProxyModel.MaxFileSizeConfigModel;
    returnUrlHash: string;
}
